
import axios from 'axios';
import { LLMQNLIResponse } from '../../types/llm';

export const getQNLIResults = async (
  question: string,
  context: string
) => {
  return await axios
    .post<LLMQNLIResponse>(
      `${process.env.REACT_APP_BACKEND_URL}/llm/qnli`,
      {
        question: question,
        context: context,
      }
    )
    .then((response) => {
      return response.data;
    });
};
